import { useEffect, useMemo, useState } from "react";
import { useAppSelector } from "@app/hooks";
import {
	selectCurrentActions,
	selectCurrentBuilder,
} from "@features/builder/builderSlice";
import { Actions } from "@typedefs/interfaces";
import { ActionsComponent } from "@utils/useTabsHook";
import MapAction from "@components/actions/map/MapAction";

const BuilderActions = () => {
	const actions = useAppSelector(selectCurrentActions);
	const { activeAction } = useAppSelector(selectCurrentBuilder);
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		// Force a re-render after initial mount to ensure proper visibility
		setMounted(true);
	}, []);

	const isActiveActionValid = useMemo(() => (activeAction !== undefined && activeAction !== null) && actions?.includes(activeAction), [activeAction, actions]);
	const isMapActive = useMemo(() => activeAction === Actions.Map && actions?.includes(activeAction), [activeAction, actions]);
	const isMapInList = useMemo(() => actions?.includes(Actions.Map), [actions]);

	return (
		<div className="builder-actions">
			{!isMapActive && isActiveActionValid ?
				<Action action={activeAction} /> : null}
			{isMapInList && <MapAction key={`map-${mounted}`} isMapActive={isMapActive} />}
		</div>
	);
};

const Action = ({ action }: { action: Actions }) => {
	return ActionsComponent[action]
};

export default BuilderActions;
